import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

export const VideoPlayer = forwardRef<
  HTMLIFrameElement,
  { src: string; title: string }
>(({ src, title }, ref) => {
  const intl = useIntl();

  return (
    <div className="relative aspect-video w-full">
      <iframe
        tabIndex={0}
        className="absolute left-0 top-0 h-full w-full border-0"
        src={src}
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; gyroscope; accelerometer; microphone"
        allowFullScreen
        title={
          title || intl.formatMessage({ id: 'learner.common.iframe.title' })
        }
        ref={ref}
      />
    </div>
  );
});

VideoPlayer.displayName = 'VideoPlayer';
